import { Badge, HStack, Icon, Text } from '@chakra-ui/react';
import { CheckCircleIcon, WarningIcon } from '@chakra-ui/icons';

interface ValidationBadgeProps {
  status: string | null;
  size?: 'sm' | 'md' | 'lg';
}

const ValidationBadge = ({ status, size = 'sm' }: ValidationBadgeProps) => {
  if (!status) return null;

  switch (status) {
    case 'pass':
      return (
        <Badge colorScheme="green" size={size}>
          <HStack spacing={1}>
            <Icon as={CheckCircleIcon} boxSize={3} />
            <Text fontSize="xs">Passed</Text>
          </HStack>
        </Badge>
      );
    case 'caution':
      return (
        <Badge colorScheme="orange" size={size}>
          <HStack spacing={1}>
            <Icon as={WarningIcon} boxSize={3} />
            <Text fontSize="xs">Caution</Text>
          </HStack>
        </Badge>
      );
    default:
      return null;
  }
};

export default ValidationBadge;
